import React, { ReactElement } from 'react';

import { IMicrositeConfiguration } from 'src/interfaces/microsite';
import { IMicrositeHomePageConfig } from 'src/interfaces/page';
import IPackageConfiguration from '@orcha/types/package';
import { MicrositeService } from 'src/services';
import ProtectedPageRoute from 'src/utilities/auth/protectedPageRoute';
import RootWidgetLayout from 'src/components/layouts/RootWidgetLayout';
import { Services } from 'src/services/types';
import { Translate } from 'next-translate';
import WidgetList from 'src/components/WidgetList';
import { myContainer } from 'src/services/inversify.config';
import { pageWidgetDataFetcher } from 'src/utilities/pageWidgetDataFetcher';
import Error from './_error';

export const HomePage = ({
  pageData,
}: {
  pageData?: IMicrositeHomePageConfig;
}) => {
  if (pageData) {
    return <WidgetList widgets={pageData?.configuredWidgets} />;
  }

  return <Error statusCode={500} />;
};

export const getServerSideProps = async (context) =>
  ProtectedPageRoute(context, async () => {
    const { req, locale } = context;
    let props = {};
    const { site } = req as { site?: IMicrositeConfiguration };
    const { packageConfig } = req as {
      packageConfig: IPackageConfiguration;
    };

    const service = myContainer.get<MicrositeService>(
      Services.MicrositeService
    );

    const pageData = site
      ? await service.getHomePage(site.tenantId, site.packageId, locale)
      : undefined;

    if (
      site &&
      packageConfig &&
      pageData?.pageType === 'Home' &&
      pageData?.configuredWidgets
    ) {
      const widgetData = await pageWidgetDataFetcher(
        pageData,
        site,
        locale,
        packageConfig
      );

      pageData.configuredWidgets = widgetData;
    }

    // Prevents serializing issue with undefined in large JSON objects (App data)
    props = JSON.parse(
      JSON.stringify({
        pageData,
        pageTitle: pageData?.pageName,
      })
    );

    return props;
  });

HomePage.getLayout = (
  page: ReactElement,
  _t: Translate,
  pageTitle?: string
) => {
  return <RootWidgetLayout pageTitle={pageTitle}>{page}</RootWidgetLayout>;
};

export default HomePage;
